import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=24e76b09&scoped=true"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"
import style0 from "./CategoryList.vue?vue&type=style&index=0&id=24e76b09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e76b09",
  null
  
)

export default component.exports